// ─── Installment Helpers ──────────────────────────────────────────────────────

import { PolicyValuesObject } from "../types/insurance.ts";

export const calcStepMonths = (
  start: moment.Moment,
  end: moment.Moment,
  count: number
) => Math.floor(end.clone().add(1, "days").diff(start, "months") / count);

const calcInstallmentAmount = (index: number, base: number, extra: number) =>
  index === 0 ? base + extra : base;

export const buildInstallment = (
  index: number,
  start: moment.Moment,
  stepMonths: number,
  policyId: number,
  base: number,
  gfSum: number,
  agentId: number,
  reportDateOverride?: string
): PolicyValuesObject => {
  const date = start.clone().add(stepMonths * index, "months");
  return {
    policyId,
    installmentDate: date.format("DD/MM/YYYY"),
    reportDate: reportDateOverride ?? date.format("DD/MM/YYYY"),
    installmentSequence: index + 1,
    accountNumber: "",
    installmentAmount: calcInstallmentAmount(index, base, gfSum),
    paymentLocation: "0",
    sticker: "",
    paidToAgent: 0,
    agentId,
    stickerAmount: 0,
    twoPercentAmount: +(base * 0.02).toFixed(2),
    greenCardCertificate: "",
  };
};
